import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@components/ui/dialog";
import React from "react";
import { Button } from "@components/ui/button";
import { Crop } from "lucide-react";

type Props = {
  open: boolean;
  handleClose: () => void;
  logo: string;
  onRecrop?: () => void;
};

const PreviewLogo: React.FC<Props> = ({
  open,
  handleClose,
  logo,
  onRecrop,
}) => {
  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent className="sm:max-h-[600px]">
        <DialogHeader>
          <DialogTitle>Plugin Logo Preview</DialogTitle>
        </DialogHeader>

        <div className="rounded-lg overflow-hidden border border-secondary bg-muted/30 p-2">
          <img
            src={logo}
            alt="Plugin Logo"
            className="w-full h-auto max-h-[380px] object-contain rounded-md"
          />
        </div>

        <div className="flex items-center justify-end gap-2">
          <Button type="button" variant="outline" onClick={handleClose}>
            Close
          </Button>
          <Button
            type="button"
            onClick={onRecrop}
            disabled={!onRecrop}
            className="gap-2"
          >
            <Crop size={15} /> Resize/Crop Again
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PreviewLogo;
